module.exports = __webpack_public_path__ + "static/media/cooper-surgical-r-md-logo-ko@3x.d56da56c.png";